
// GETTERS
export const GET_IS_ADMIN = 'GET_IS_ADMIN';
export const GET_IS_ACCOUNT_MANAGER = 'GET_IS_ACCOUNT_MANAGER';

// ACTIONS
export const SIGN_IN = 'SIGN_IN';
export const SIGN_UP = 'SIGN_UP';
export const SIGN_OUT = 'SIGN_OUT';
export const CONFIRM_SIGN_UP = 'CONFIRM_SIGN_UP';
export const RESEND_SIGN_UP = 'RESEND_SIGN_UP';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const CONFIRM_FORGOT_PASSWORD = 'CONFIRM_FORGOT_PASSWORD';
export const COMPLETE_NEW_PASSWORD = 'COMPLETE_NEW_PASSWORD';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

// MUTATIONS
export const SET_USER = 'SET_USER';
export const SET_USER_ROLES = 'SET_USER_ROLES';
export const RESET_USER = 'RESET_USER';
